import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import classNames from 'classnames';

const ConfirmLeave = ({ open, onConfirm, onCancel }) => (
  <Modal show={open} bsSize="sm" onHide={() => console.log('12')} backdrop="static" className={classNames('modal__confirm level-system__modal-confirm')}>
    <Modal.Body>
      <div className="modal__confirm-title">You have unsaved changes</div>
      <div className="modal__confirm-description">
        <div>Your changes will not be saved. </div>
        <div>Are you sure you want to close this window?</div>
      </div>
      <div className="modal__confirm-actions">
        <Button
          onClick={onConfirm}
          bsStyle="primary"
          type="button"
        >
          <span>Leave</span>
        </Button>
        <Button
          onClick={onCancel}
        >
          <span>Cancel</span>
        </Button>
      </div>
    </Modal.Body>
  </Modal>
)

ConfirmLeave.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmLeave;
